import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/modules/shared.module';
import { TicketScannerComponent } from './ticket.scanner.component';
import { RouterModule, Routes } from '@angular/router';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ScannerTicketComponent } from './scanner-ticket.component';
import { UtilsModule } from '@app/modules/utils.module';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
  {
    path: 'scan',
    component: TicketScannerComponent,
  },
  {
    path: 'slipDetail/:slipid',
    component: ScannerTicketComponent,
  },
];

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, ZXingScannerModule, RouterModule.forChild(routes), UtilsModule, TranslateModule],
  declarations: [TicketScannerComponent, ScannerTicketComponent],
  exports: [],
  providers: [ScrollDispatcher],
})
export class ScannerModule {}
